<template>
  <Modal :name="name" custom persistent>
    <WarRoomOnboardingJobSearch
      class="war-room-onboarding-job-search-modal"
      :next-route="nextRoute"
      :step="2"
      :step-count="2"
    />
  </Modal>
</template>

<script>
import WarRoomOnboardingJobSearch from '@/components/partials/war-room-onboarding/WarRoomOnboardingJobSearch';
import Modal from '~/components/common/Modal/Modal';
import { ONBOARDING_JOB_SEARCH_MODAL } from '~/constants/dynamicModals';
import { ANNOUNCEMENT_FEATURES } from '~/components/common/AnnouncementModal/constants';

export default {
  name: 'WarRoomOnboardingJobSearchModal',
  components: {
    WarRoomOnboardingJobSearch,
    Modal,
  },
  data() {
    const query = ANNOUNCEMENT_FEATURES.some(feature => !this.$tooltip.isPresent(feature.tooltipName))
      ? { dynamic_modal: this.$constants.dynamicModals.WAR_ROOM_ANNOUNCEMENT_MODAL }
      : {};
    return {
      name: ONBOARDING_JOB_SEARCH_MODAL,
      nextRoute: { query },
    };
  },
};
</script>

<style lang="scss" scoped>
.war-room-onboarding-job-search-modal {
  min-height: 100vh;
  width: 100%;

  @include mq('sm') {
    width: 592px;
    min-height: auto;
  }
}
</style>
